import React, { useState } from "react";
import { Modal, Button, Form, Alert, Spinner } from "react-bootstrap";

const EnquiryModal = ({ show, onHide, product }) => {
  const [form, setForm] = useState({
    quantity: "",
    unit: "Pieces",
    countryCode: "+91",
    phone: "",
    message: "",
  });

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  const handleChange = (e) => {
    setError("");
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const validate = () => {
    if (!form.quantity || Number(form.quantity) <= 0)
      return "Please enter a valid quantity";

    if (!/^\d{8,15}$/.test(form.phone))
      return "Please enter a valid mobile number";

    return null;
  };

  const handleSubmit = async () => {
    const validationError = validate();
    if (validationError) {
      setError(validationError);
      return;
    }
    if (!navigator.onLine) {
      setError("No internet connection. Please check your network.");
      return;
    }

    setLoading(true);
    setError("");
    setSuccess("");

    try {
      //const response = await fetch("/Backend/enquiry.php", {
      const response = await fetch(
        "https://royalgreenenergy.co.in/Backend/enquiry.php",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            product_name: product.name,
            quantity: form.quantity,
            unit: form.unit,
            phone: `${form.countryCode}${form.phone}`,
            message: form.message,
          }),
        },
      );

      if (!response.ok) {
        throw new Error("Server is not responding");
      }

      const data = await response.json();

      if (!data.success) {
        throw new Error(data.message || "Failed to submit enquiry");
      }

      setSuccess("Enquiry submitted successfully");

      const whatsappNumber = "919890099992";

      const whatsappMessage = `
*New Product Enquiry*

Product: ${product.name}

Quantity: ${form.quantity} ${form.unit}

Customer Number:
${form.countryCode}${form.phone}

Additional Details:
${form.message || "N/A"}
`;

      const whatsappUrl = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(
        whatsappMessage,
      )}`;

      const whatsappWindow = window.open("", "_blank");

      if (whatsappWindow) {
        whatsappWindow.location.href = whatsappUrl;
      }

      setTimeout(() => {
        onHide();
        setForm({
          quantity: "",
          unit: "Pieces",
          countryCode: "+91",
          phone: "",
          message: "",
        });
      }, 1200);
    } catch (err) {
      if (err.name === "TypeError") {
        setError("Please check your internet connection");
      } else {
        setError(err.message || "Unexpected error occurred");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal show={show} onHide={onHide} centered backdrop="static">
      <Modal.Header closeButton>
        <Modal.Title>Quick Enquiry</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <div className="d-flex align-items-center gap-3 border rounded p-3 mb-3 bg-light">
          <img
            src={product.image}
            alt={product.name}
            style={{
              width: "60px",
              height: "60px",
              objectFit: "contain",
              borderRadius: "6px",
              background: "#fff",
            }}
          />

          <div>
            <strong>{product.name}</strong>
          </div>
        </div>

        {error && <Alert variant="danger">{error}</Alert>}
        {success && <Alert variant="success">{success}</Alert>}

        <Form.Group className="mb-3">
          <Form.Label>Quantity *</Form.Label>
          <Form.Select
            name="quantity"
            value={form.quantity}
            onChange={handleChange}
          >
            <option value="">Select Quantity</option>
            <option value="100">100</option>
            <option value="200">200</option>
            <option value="350">350</option>
            <option value="500">500</option>
            <option value="850">850</option>
            <option value="1000">1000</option>
            <option value="1250">1250</option>
          </Form.Select>
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label>Unit</Form.Label>
          <Form.Select name="unit" value={form.unit} onChange={handleChange}>
            <option>Piece\Pieces</option>
          </Form.Select>
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label>WhatsApp Number *</Form.Label>

          <div className="d-flex gap-2">
            {/* Country Code */}
            <Form.Select
              name="countryCode"
              value={form.countryCode}
              onChange={handleChange}
              style={{ maxWidth: "110px" }}
            >
              <option value="+91">🇮🇳 +91</option>
              <option value="+1">🇺🇸 +1</option>
              <option value="+44">🇬🇧 +44</option>
              <option value="+971">🇦🇪 +971</option>
              <option value="+61">🇦🇺 +61</option>
              <option value="+65">🇸🇬 +65</option>
            </Form.Select>

            {/* Phone Number */}
            <Form.Control
              name="phone"
              placeholder="Mobile number"
              value={form.phone}
              onChange={handleChange}
              maxLength={15}
            />
          </div>
        </Form.Group>
        <Form.Group className="mb-3">
          <Form.Label>Additional Details</Form.Label>
          <Form.Control
            as="textarea"
            rows={3}
            name="message"
            value={form.message}
            onChange={handleChange}
          />
        </Form.Group>
      </Modal.Body>

      <Modal.Footer>
        <Button
          variant="success"
          className="w-100"
          onClick={handleSubmit}
          disabled={loading || !navigator.onLine}
        >
          {loading ? <Spinner size="sm" /> : "Submit Enquiry"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
export default EnquiryModal;
